import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { profile } from 'config/config'; // Importing profile configuration

/**
 * Class representing a filter view for agent list.
 * @extends JetView
 */
export default class FilterAgentListView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration
        const id_partner = this.getParam('partner', true); // Get partner ID from parameters

        // Filter configuration with a dropdown for countries
        const filter = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'richselect', // Dropdown component
                    name: 'Country',
                    localId: 'regions:combo', // Local ID for referencing
                    label: "<span class='icon-language'></span>" + _('País'), // Label with icon
                    labelPosition: 'top', // Position of the label
                    placeholder: _('Click para seleccionar '), // Placeholder text
                    options: [], // Options for the dropdown
                    id: 'Countries', // ID for the dropdown
                },
            ],
        };

        // Upper section layout containing the filter
        const upper_section = {
            id: 'a1',
            rows: [
                {
                    responsive: 'a1', // Responsive layout identifier
                    margin: 10,
                    cols: [filter], // Include filter in columns
                },
            ],
        };

        // Button configuration for submitting the filter
        const buttons = {
            id: 'b2',
            rows: [
                {
                    margin: 10,
                    responsive: 'b2', // Responsive layout identifier
                    cols: [
                        {
                            view: 'button', // Button component
                            value: _('Consultar'), // Button label
                            hotkey: 'enter', // Hotkey for the button
                            type: 'form', // Button type
                            minWidth: 200,
                            click: () => {
                                // Click event handler
                                $$('formSettingsPartner').show(); // Show partner settings form
                                const filterdata = this.getRoot().getValues(); // Get form values
                                filterdata.Partner = id_partner; // Add partner ID to filter data
                                this.app.callEvent('partnerSettings:filter', [filterdata]); // Trigger filter event
                            },
                        },
                    ],
                },
            ],
        };

        // Return the complete form configuration
        return {
            view: 'form', // Form component
            id: 'formFilter', // ID for the form
            rows: [upper_section, buttons], // Include upper section and buttons
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for the form
            },
        };
    }

    /**
     * Initializes the view and sets up event handlers.
     */
    init() {
        var vthis = this; // Preserve context for event handlers
        const _ = this.app.getService('locale')._; // Localization service
        const id_partner = this.getParam('partner', true); // Get partner ID from parameters
        const partners = profile.Partners; // Retrieve partners from profile

        // Function to filter partners based on ID
        function filter_partners(partners) {
            return partners.id == id_partner; // Return true if partner ID matches
        }

        var partner = partners.filter(filter_partners); // Filter partners to find the relevant one
        $$('Countries').define('options', partner[0].Countries); // Define options for the countries dropdown
        $$('Countries').refresh(); // Refresh the dropdown to show new options

        // Event handler for when the country selection changes
        $$('Countries').attachEvent('onChange', function (newv) {
            $$('formSettingsPartner').show(); // Show partner settings form
            const filterdata = $$('formFilter').getValues(); // Get current form values
            filterdata.Partner = partner[0].id; // Set partner ID in filter data
            console.log('Filtro Partner', filterdata); // Log the filter data
            vthis.app.callEvent('partnerSettings:filter', [filterdata]); // Trigger filter event
        });
    }
}

// FILE DOCUMENTED
